import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';

interface IPageDo0067 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    cimMultiOccurrenceOptions: IMultiOccurrenceOptions;
    cioMultiOccurrenceOptions: IMultiOccurrenceOptions;
    cilMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireCriteres: IFormulaire;
}

/* @ngInject */
export default function Do0067Controller(
    Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass
) {
    const vm: IPageDo0067 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    vm.monoOccurrenceOptions = {
        id: vm.valeursEcran.ciacleint,
        fonctions: {
            boutonDupliquer: false
        },
        formulaire: new Formulaire('LBL_ATF', [
            new FormulaireItem('ciaadrcou', {
                largeur: 33,
                historiqueColonne: true
            }),
            new FormulaireItem('ciaurldec', {
                largeur: 33
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('tadcleint', {
                largeur: 33
            }),
            new FormulaireItem('ciaflgtadobl', {
                largeur: 33
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('ttlcleintmai', {
                largeur: 33
            }),
            new FormulaireItem('ciaflgttlmaiobl', {
                largeur: 33
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('ttlcleintbur', {
                largeur: 33
            }),
            new FormulaireItem('ciaflgttlburobl', {
                largeur: 33
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('ciaflgdatperobl', {
                largeur: 33
            }),
            new FormulaireItem('ciaflgpjextobl', {
                largeur: 33
            }),
            new FormulaireItem('ciaflgdatnaiobl', {
                largeur: 33
            }),
            new FormulaireItem('ciaflgnasobl', {
                largeur: 33
            }),
            new FormulaireItem('ciaflgcouintobl', {
                largeur: 33
            }),
            new FormulaireItem('ciaflgetrobl', {
                largeur: 33
            }),
            // Emplois offerts
            new FormulaireGroupeAccordeon(
                'LBL_EMP_OFF', 
                new Formulaire([
                    new FormulaireItem('ciaflgdscempobl', {
                        largeur: 33
                    }),
                    new FormulaireItem('ciaflgquaexiobl', {
                        largeur: 33
                    }),
                    new FormulaireItemSautDeLigne(),
                    new FormulaireItem('ciaflgresobl', {
                        largeur: 33
                    }),
                    new FormulaireItem('ciaflgsupobl', {
                        largeur: 33
                    }),
                    new FormulaireItem('ciaflggendscder', {
                        largeur: 33
                    })
                ])
            ),
            // Portail
            new FormulaireGroupeAccordeon(
                'LBL_PORT', 
                new Formulaire([
                    new FormulaireItem('ciahiscanmois', {
                        largeur: 33
                    }),
                    new FormulaireItem('ciajrssupdes', {
                        largeur: 33
                    }),
                    new FormulaireItem('ciaflgcieextdef', {
                        largeur: 33
                    }),
                ])
            ),
            // Type de transaction 
            new FormulaireGroupeAccordeon(
                'LBL_TYPES_TRNS', 
                new Formulaire([
                    new FormulaireItem('ttccleintepl', {
                        largeur: 33
                    }),
                    new FormulaireItem('ttccleintdem', {
                        largeur: 33
                    }),
                    new FormulaireItem('ttccleintlem', {
                        largeur: 33
                    }),
                    new FormulaireItem('ttccleintmajlem', {
                        largeur: 33
                    })
                ])
            ),
            // Analyse des candidatures 
            new FormulaireGroupeAccordeon(
                'LBL_ANALYSE_CAND', 
                new Formulaire([
                    new FormulaireItem('bqecleintglobal', {
                        largeur: 50
                    }),
                    new FormulaireItem('bqecleintcrs', {
                        largeur: 50
                    }),
                    new FormulaireItemSautDeLigne(),
                    new FormulaireItem('ciavaldefselcan', {
                        largeur: 50
                    }),
                    new FormulaireItem('vaeciaaffcomana', {
                        largeur: 50
                    })
                ])
            )])
    }


    vm.formPar = new Formulaire('LBL_PORT', [
        new FormulaireItem('ciahiscanmois', {
            largeur: 100
        }),
        new FormulaireItem('ciajrssupdes', {
            largeur: 100
        })
    ]);

    vm.formPar2 = new Formulaire('LBL_EMP_OFF', [
        new FormulaireItem('ciaflgdscempobl', {
            largeur: 100
        }),
        new FormulaireItem('ciaflgquaexiobl', {
            largeur: 100
        }),
        new FormulaireItem('ciaflggendscder', {
            largeur: 100
        }),
        new FormulaireItem('ciaflgresobl', {
            largeur: 100
        })
    ]);

    vm.formPar3 = new Formulaire('LBL_PORT_EMP', [
        new FormulaireItem('ciaflgcieextdef', {
            largeur: 100
        }),
    ]);

    vm.cimMultiOccurrenceOptions = {
        bloc: 'cim',
        colonnesVisibles: [
            { nom: 'temcod', largeur: 190 },
            { nom: 'temdscabr', largeur: 190 },
            { nom: 'urgcod', largeur: 190 },
            { nom: 'urgdscabr', largeur: 190 },
            { nom: 'strcod', largeur: 190 },
            { nom: 'strdsc', largeur: 190 },
            { nom: 'tlecod', largeur: 190 },
            { nom: 'tledsc', largeur: 190 },
            { nom: 'vaecimtypor', largeur: 190 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('temcleint', {
                largeur: 33
            }),
            new FormulaireItem('urgcleint', {
                largeur: 33,
                resourceParams: (data: any) => ({ temcleint: data.temcleint })
            }),
            new FormulaireItem('strcleint', {
                largeur: 33,
                resourceParams: (data: any) => ({ urgcleint: data.urgcleint })
            }),
            new FormulaireItem('tlecleint', {
                largeur: 33
            }),
            new FormulaireItem('vaecimtypor', {
                largeur: 33
            }),
        ])
    };

    vm.cioMultiOccurrenceOptions = {
        bloc: 'cio',
        colonnesVisibles: [
            { nom: 'temcod', largeur: 20 },
            { nom: 'temdscabr', largeur: 20 },
            { nom: 'tdmcod', largeur: 20 },
            { nom: 'tdmdsc', largeur: 20 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('temcleint', {
                largeur: 33
            }),
            new FormulaireItem('tdmcleint', {
                largeur: 33
            }),
        ])
    };
    vm.ciaMultiOccurrenceOptions = {
        bloc: 'cia',
        colonnesVisibles: [
            { nom: 'rolcod', largeur: 130 },
            { nom: 'roldscabr', largeur: 130 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('rolcleint', {
                largeur: 33
            })
        ])
    }

}
